import App from "./app.svelte";

const app = document.getElementById("app")!;
new App({
  target: app,
  props: {
    language: app.dataset.langauge || "ko",
  },
});
